<template>
  <div class="ads-revenue">
    <div class="content-header-wrap">
      <content-header
        :header_title="header_title">
        <div></div>
      </content-header>
    </div>
    <div class="filter-box-wrap">
      <DatePicker
        class="time-filter"
        type="daterange"
        :options="date_picker_option"
        :clearable="false"
        v-model="filter.time"
        placeholder="日期"
        style="width: 200px"
        @on-change="handleDateChange"/>
    </div>
    <div class="content-box">
      <div class="table-wrap">
        <div class="table-header">
          <h2 class="title">{{ revenue_table_title }}</h2>
          <table-operation
            :columns="revenue_table_columns"
            :table_data="revenue_table_data"></table-operation>
        </div>
        <div class="table" ref="revenue_table">
          <Table
            :columns="revenue_table_columns"
            :data="revenue_table_data"></Table>
        </div>
        <div class="page-box">
          <Page
            :total="revenue_total"
            :current="revenue_page_num"
            :page-size="revenue_page_size"
            @on-change="revenuePageNumChange"
            @on-page-size-change="revenuePageSizeChange"
            size="small" show-elevator show-sizer/>
        </div>
      </div>
      <div class="chart-wrap"
           :class="{'first-chart-wrap': index === 0}"
           v-for="(item, index) in chart_list"
           :key="item.name">
        <h2 class="title">{{ item.title }}</h2>
        <div class="container">
          <div class="chart" :ref="item.name" v-show="item.chart_visible"></div>
          <div class="empty-result-container" v-show="!item.chart_visible">
            <Icon class="empty-icon" size="72" type="ios-folder-open-outline" color="#e1e1e1"/>
            <p class="empty-text">数据不足</p>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../../../components/ContentHeader.vue';
import TableOperation from '../../../../components/TableOperation.vue';
import routerTriggerMixin from '../routerTriggerMixin';
import paramNameJSON from './paramName.json';
import getBarChartOption from '../../../../utils/getBarChartOption';
import chartColorMixin from '../mixin/chartColorMixin';
import getLineChartOption from '../../../../utils/getLineChartOption';
import getPieChartOption from '../../../../utils/getPieChartOption';

export default {
  name: 'AdsRevenue',
  mixins: [routerTriggerMixin, chartColorMixin],
  components: { TableOperation, ContentHeader },
  computed: {
    project_id() {
      return this.$route.params.project_id;
    },
    revenue_render() {
      return (h, p) => {
        const { key } = p.column;
        const value = p.row[key];
        if (key === 'iap_ratio') {
          return h('span', this.$tools.percentageFormat(value));
        }
        return h('span', value);
      };
    },
  },
  data() {
    return {
      header_title: '收入',
      date_picker_option: {
        shortcuts: [
          {
            text: '最近一周',
            value() {
              const today = new Date();
              const endDate = new Date(today.getTime() - 3600 * 1000 * 24 * 1);
              const startDate = new Date(endDate.getTime() - 3600 * 1000 * 24 * 7);
              return [startDate, endDate];
            },
          },
          {
            text: '最近两周',
            value() {
              const today = new Date();
              const endDate = new Date(today.getTime() - 3600 * 1000 * 24 * 1);
              const startDate = new Date(endDate.getTime() - 3600 * 1000 * 24 * 14);
              return [startDate, endDate];
            },
          },
          {
            text: '最近30天',
            value() {
              const today = new Date();
              const endDate = new Date(today.getTime() - 3600 * 1000 * 24 * 1);
              const startDate = new Date(endDate.getTime() - 3600 * 1000 * 24 * 30);
              return [startDate, endDate];
            },
          },
          {
            text: '最近60天',
            value() {
              const today = new Date();
              const endDate = new Date(today.getTime() - 3600 * 1000 * 24 * 1);
              const startDate = new Date(endDate.getTime() - 3600 * 1000 * 24 * 60);
              return [startDate, endDate];
            },
          },
        ],
        disabledDate: (date) => date >= Date.now(),
      },
      // Filter
      filter: {
        time: [],
      },
      // Chart
      chart_list: [
        {
          name: 'revenue_bar_chart',
          title: '总收入柱状图',
          request_name: 'getAdsRevenueBarData',
          param_name: 'revenue',
          chart_visible: true,
          chart: null,
        },
        {
          name: 'revenue_ads_bar_chart',
          title: '广告收入柱状图',
          request_name: 'getAdsAdsRevenueBarData',
          param_name: 'ads_revenue',
          chart_visible: true,
          chart: null,
        },
        {
          name: 'revenue_sale_bar_chart',
          title: '内购收入柱状图',
          request_name: 'getAdsSaleRevenueBarData',
          param_name: 'sale_revenue',
          chart_visible: true,
          chart: null,
        },
        {
          name: 'revenue_sale_ads_line_chart',
          title: '内购广告收入折线图',
          request_name: 'getAdsRevenueSaleLineData',
          param_name: 'ads_revenue',
          chart_visible: true,
          chart: null,
        },
        {
          name: 'revenue_pie_chart',
          title: '收入饼状图',
          request_name: 'getAdsRevenueDistributePieData',
          param_name: 'revenue',
          chart_visible: true,
          chart: null,
        },
      ],
      revenue_chart: {
        name: 'revenue_sale_bar_chart',
        title: '内购收入柱状图',
        param_name: 'sale_revenue',
        chart_visible: true,
        chart: null,
      },
      // Table
      revenue_table_title: '收入报表',
      revenue_table_columns: [],
      revenue_table_data: [],
      // Page
      revenue_total: 0,
      revenue_page_num: 1,
      revenue_page_size: 10,
    };
  },
  methods: {
    fetchData() {
      this.fetchRevenueData();
    },
    fetchRevenueData() {
      const instance1 = this.$loading(this.$refs.revenue_table);
      const tablePromise = this.fetchRevenueTableData()
        .then((response) => {
          this.tableDataCallback(response.data, 'revenue');
        })
        .finally(() => {
          instance1.hide();
        });
      const chartPromiseList = this.fetchAllChartsData();
      Promise.all([tablePromise, ...chartPromiseList])
        .catch((error) => {
          this.$Message.error(error.message);
        });
    },
    fetchRevenueTableData() {
      const params = {
        date_start: this.$tools.dateFormat(this.filter.time[0]),
        date_end: this.$tools.dateFormat(this.filter.time[1]),
        page_num: this.revenue_page_num,
        page_size: this.revenue_page_size,
      };
      return this.$api.getAdsRevenueTableData(this.project_id, params);
    },
    tableDataCallback(responseData, tableName) {
      if (!responseData) {
        this[`${tableName}_table_columns`] = [];
        this[`${tableName}_table_data`] = [];
        return;
      }
      this[`${tableName}_table_columns`] = [];
      this[`${tableName}_table_data`] = [];
      const columns = this[`${tableName}_table_columns`];
      const data = this[`${tableName}_table_data`];
      const { header, record, total } = responseData;
      this[`${tableName}_total`] = total;
      // eslint-disable-next-line no-restricted-syntax
      for (const key of header) {
        const obj = {
          key,
          title: paramNameJSON[key],
          minWidth: 120,
          fixed: key === 'date' ? 'left' : null,
          render: this.revenue_render,
        };
        columns.push(obj);
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const rowData of record) {
        data.push(rowData);
      }
    },
    fetchSingleChartData(requestName) {
      const params = {
        date_start: this.$tools.dateFormat(this.filter.time[0]),
        date_end: this.$tools.dateFormat(this.filter.time[1]),
      };
      return this.$api[requestName](this.project_id, params);
    },
    fetchAllChartsData() {
      const promiseList = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of this.chart_list) {
        const instance = this.$loading(this.$refs[item.name][0]);
        const requestName = item.request_name;
        const promise = this.fetchSingleChartData(requestName);
        promise.then((response) => {
          this.fetchChartDataCallback(response?.data, item);
        }).finally(() => {
          instance.hide();
        });
        promiseList.push(promise);
      }
      return promiseList;
    },
    fetchChartDataCallback(responseData, item) {
      if (!responseData) {
        // eslint-disable-next-line no-param-reassign
        item.chart_visible = false;
        return;
      }
      // eslint-disable-next-line no-param-reassign
      item.chart_visible = true;
      this.$nextTick(() => {
        this.drawChart(responseData, item);
      });
    },
    fetchRevenueChartData() {
      const params = {
        date_start: this.$tools.dateFormat(this.filter.time[0]),
        date_end: this.$tools.dateFormat(this.filter.time[1]),
      };
      return this.$api.getAdsSaleRevenueBarData(this.project_id, params);
    },
    chartDataCallback(responseData) {
      if (!responseData) {
        // eslint-disable-next-line no-param-reassign
        this.revenue_chart.chart_visible = false;
        return;
      }
      // eslint-disable-next-line no-param-reassign
      this.revenue_chart.chart_visible = true;
      this.$nextTick(() => {
        this.drawChart(responseData, this.revenue_chart);
      });
    },
    drawChart(data, chartItem) {
      const ref = chartItem.name;
      const chartElement = this.$refs[ref][0];
      if (!chartElement) return;
      const chartData = this.getPackedUpChartData(data, chartItem.param_name);
      const configuration = this.getPackedUpChartConfiguration(data);
      const chartInstance = chartItem.chart;
      if (chartInstance) chartInstance.clear();
      if (data.type === 'line' || data.type === 'multi_line') {
        const chart = this.$echarts.init(chartElement);
        const option = getLineChartOption(chartData, configuration);
        chart.setOption(option);
        // eslint-disable-next-line no-param-reassign
        chartItem.chart = chart;
      } if (data.type === 'pie') {
        const chart = this.$echarts.init(chartElement);
        const option = getPieChartOption(chartData, configuration);
        chart.setOption(option);
        // eslint-disable-next-line no-param-reassign
        chartItem.chart = chart;
      } if (data.type === 'column' || data.type === 'multi_column') {
        const chart = this.$echarts.init(chartElement);
        const option = getBarChartOption(chartData, configuration);
        chart.setOption(option);
        // eslint-disable-next-line no-param-reassign
        chartItem.chart = chart;
      }
    },
    getPackedUpChartData(data, name) {
      const chartData = {};
      const { type } = data;
      if (type === 'line' || type === 'column') {
        chartData.name = paramNameJSON[name];
        chartData.x_axis = data.x_axis;
        chartData.y_axis = data.y_axis;
        // eslint-disable-next-line prefer-destructuring
        chartData.color = this.chart_color_list[0];
        chartData.area_color = this.chart_area_color;
        // eslint-disable-next-line prefer-destructuring
        chartData.tooltip_color = this.chart_tooltip_color_list[0];
        // eslint-disable-next-line prefer-destructuring
        chartData.mark_color = this.chart_mark_color_list[0];
        return chartData;
      } if (type === 'multi_line' || type === 'multi_column') {
        chartData.x_axis = data.x_axis;
        chartData.y_axis = [];
        chartData.name_list = [];
        chartData.color = [];
        chartData.tooltip_color = [];
        chartData.mark_color = [];
        let count = 0;
        // eslint-disable-next-line no-restricted-syntax
        for (const item of data.dimension) {
          const dimensionData = data[item];
          chartData.color.push(this.chart_color_list[count]);
          chartData.tooltip_color.push(this.chart_tooltip_color_list[count]);
          chartData.mark_color.push(this.chart_mark_color_list[count]);
          chartData.name_list.push(paramNameJSON[item]);
          chartData.y_axis.push(dimensionData);
          count += 1;
        }
        return chartData;
      } if (type === 'pie') {
        chartData.data = data.data || data.record;
        chartData.color = [];
        const { length } = chartData.data;
        for (let i = 0; i < length; i += 1) {
          const currentColor = this.chart_color_list[i % length];
          chartData.color.push(currentColor);
          chartData.data[i].name = paramNameJSON[chartData.data[i].name];
        }
        return chartData;
      }
      return null;
    },
    getPackedUpChartConfiguration(data) {
      const { type, unit } = data;
      const grid = {
        top: '12px',
        right: '12px',
        bottom: '24px',
        left: '40px',
      };
      if (type === 'line' || type === 'column') {
        const configuration = {
          grid,
          x: {
            hideMaxLabel: true,
          },
          y: {
            formatter: unit,
          },
          series: {
            formatter: unit,
          },
        };
        return configuration;
      } if (type === 'multi_line' || type === 'multi_column') {
        grid.top = '36px';
        const configuration = {
          grid,
          x: {
            hideMaxLabel: true,
          },
          y: {
            formatter: unit,
            multiple: true,
          },
          series: {
            formatter: unit,
            lineStyle: {
              width: 1.8,
            },
            showTotal: true,
          },
        };
        return configuration;
      } if (type === 'pie') {
        const configuration = {
          series: {
            formatter: unit,
          },
        };
        return configuration;
      }
      return null;
    },
    changeChartWrapHeight() {
      const chartWrapElements = document.getElementsByClassName('chart-wrap');
      const chartWrapElement = chartWrapElements[0];
      const width = chartWrapElement.clientWidth;
      // eslint-disable-next-line no-restricted-syntax
      for (const element of chartWrapElements) {
        element.style.height = `${width * 0.36}px`;
      }
    },
    revenuePageNumChange(pageNumber) {
      this.revenue_page_num = pageNumber;
      const instance = this.$loading(this.$refs.revenue_table);
      this.fetchRevenueTableData()
        .then((response) => {
          this.tableDataCallback(response.data, 'revenue');
        })
        .catch((error) => {
          this.$Message.error(error.message);
        })
        .finally(() => {
          instance.hide();
        });
    },
    revenuePageSizeChange(pageSize) {
      this.revenue_page_size = pageSize;
      this.revenue_page_num = 1;
      const instance = this.$loading(this.$refs.revenue_table);
      this.fetchRevenueTableData()
        .then((response) => {
          this.tableDataCallback(response.data, 'revenue');
        })
        .catch((error) => {
          this.$Message.error(error.message);
        })
        .finally(() => {
          instance.hide();
        });
    },
    handleDateChange() {
      this.revenue_page_num = 1;
      this.fetchRevenueData();
    },
    initTimeFilter() {
      const today = new Date();
      const endDate = new Date(today.getTime() - 3600 * 1000 * 24 * 1);
      const startDate = new Date(endDate.getTime() - 3600 * 1000 * 24 * 30);
      this.filter.time = [startDate, endDate];
    },
  },
  mounted() {
    this.fetchData();
    this.changeChartWrapHeight();
    window.addEventListener('resize', this.changeChartItemHeight);
  },
  created() {
    this.initTimeFilter();
  },
  destroyed() {
    window.removeEventListener('resize', this.changeChartItemHeight);
  },
};
</script>

<style scoped lang="less">
  @boxBorder: 1px solid #EAEBF7;
  @borderRadius: 7px;
  .h2Title {
    font-size: 16px;
    font-weight: 600;
    color: #202444;
    line-height: 22px;
  }
  .ads-revenue {
    .content-header-wrap {
      margin: 24px;
    }
    .title {
      display: inline-block;
      width: 100%;
      margin: 0 0 20px 0;
      .h2Title();
    }
    .filter-box-wrap {
      margin: 0 24px 20px;
      padding: 24px;
      background: #ffffff;
      border-radius: @borderRadius;
      border: 1px solid #EAEBF7;
    }
    .content-box {
      padding: 0 calc(~'24px - 1%');
      .chart-wrap {
        position: relative;
        width: 48%;
        margin: 0 1% 2%;
        padding: 18px;
        float: left;
        border: 1px solid #EAEBF7;
        border-radius: 7px;
        background-color: #ffffff;
        .container {
          position: relative;
          height: calc(~'100% - 42px');
          .chart {
            height: 100%;
          }
        }
        .empty-result-container {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          text-align: center;
          .empty-icon {
            margin-bottom: 12px;
          }
          .empty-text {
            font-size: 20px;
            font-weight: 400;
            color: #c1c1c1;
          }
        }
      }
      .first-chart-wrap {
        width: 98%;
        margin: 0 1% 2%;
      }
      .table-wrap {
        margin: 0 1% 2%;
        float: left;
      }
      .table-wrap {
        width: 98%;
        padding: 20px 24px;
        background-color: #ffffff;
        border-radius: @borderRadius;
        border: @boxBorder;
        box-sizing: border-box;
        .table-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          .title {
            width: auto;
            margin: 0;
            line-height: 22px;
          }
        }
        /*.table-show-number {*/
        /*  display: flex;*/
        /*  flex-direction: row-reverse;*/
        /*  margin-bottom: 6px;*/
        /*}*/
        .table {
          position: relative;
          min-height: 120px;
        }
        .page-box {
          display: flex;
          flex-direction: row-reverse;
          justify-content: space-between;
          align-items: center;
          height: 48px;
        }
      }
    }
    .clear {
      clear: both;
    }
  }
</style>
